import React from "react";
import OfficeToPdfConverter from "../../components/OfficeToPdfConverter";

const Powerpoint2Pdf = () => (
  <OfficeToPdfConverter
    documentLabel="PowerPoint"
    title={
      <>
        Convert <b>POWERPOINT</b> documents to <b>PDF</b>.
      </>
    }
    description="Make your PPT and PPTX files more accessible by converting them to PDF."
    accept=".ppt,.pptx"
    emptyMessage="Please select one or more PPT or PPTX files."
  />
);

export default Powerpoint2Pdf;
